import { render, staticRenderFns } from "./the-prototype.vue?vue&type=template&id=08217bda&"
import script from "./the-prototype.vue?vue&type=script&lang=js&"
export * from "./the-prototype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports